import { IValidationRule } from "@/types"

const overheadFactorsValidationRules: { [s: string]: IValidationRule } = {
    assetTypeId: {
        required: true,
    },
    overheadWarranty: {
        required: true,
        type: "decimal",
        min: 0,
        max: 100,
    },
    overheadAdministration: {
        required: true,
        type: "decimal",
        min: 0,
        max: 100,
    },
    overheadSales: {
        required: true,
        type: "decimal",
        min: 0,
        max: 100,
    },
}

export default overheadFactorsValidationRules
